import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputTextOutlined from '@components/InputTextOutlined';
import PrimaryButton from '@components/PrimaryButton';
import { useAuthContext } from '@hooks';
import { switchBetweenLabelAndPlaceholder } from '@utils';
import './style.css';

const APPLICATION = 'staff';

const EnterEmail = ({ email, setEmail, updateIsVerificationScreen }) => {
  const { t } = useTranslation(['pointOfService', 'auth']);

  const { establishSession } = useAuthContext();

  const [isPlaceholderEmailShow, setPlaceholderEmailShow] = useState(true);
  const [isLabelEmailShow, setLabelEmailShow] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleChangeEmail = ({ target }) => {
    setEmail(target.value);

    switchBetweenLabelAndPlaceholder({
      condition: target.value.length > 0,
      setLabel: setLabelEmailShow,
      setPlaceholder: setPlaceholderEmailShow,
    });
  };

  const handleDisplayPlaceholderInput = () => {
    setPlaceholderEmailShow(!isPlaceholderEmailShow);
  };

  const handleDisplayLabelOrPlaceholder = () => {
    if (email.length > 0) {
      setLabelEmailShow(true);
    } else {
      setPlaceholderEmailShow(true);
    }
  };

  const signInEmail = async () => {
    setLoading(true);
    await establishSession(email, APPLICATION);
    updateIsVerificationScreen(true);
  };

  return (
    <div className="auth-bg" style={{ color: '#fff' }}>
      <div className="auth-box">
        <h2>Please identify yourself</h2>
        <InputTextOutlined
          type="email"
          value={email}
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          placeholder={t('auth:placeholders.email')}
          handleChangeInput={handleChangeEmail}
          handleDisplayPlaceholderInput={handleDisplayPlaceholderInput}
          handleDisplayLabelOrPlaceholder={handleDisplayLabelOrPlaceholder}
          isPlaceholderInputDisplayed={isPlaceholderEmailShow}
          isLabelInputDisplayed={isLabelEmailShow}
          required
        />
        <PrimaryButton
          text={t('buttons.thatsMeButton')}
          handleClick={signInEmail}
          isDisabledButton={!email || isLoading}
        />
        {/* <PrimaryButton
          text={t('buttons.cancelButton')}
          handleClick={redirectToLandingPage}
        /> */}
      </div>
    </div>
  );
};

export default EnterEmail;
